import { Component, Input } from '@angular/core';

/** Statuts connus : texte + couleur (jamais la couleur seule) */
const STATUTS: { [k: string]: { label: string; cls: string; icon?: string } } = {
  PAYE: { label: 'Payé', cls: 'ok', icon: 'check' },
  PAYEE: { label: 'Payée', cls: 'ok', icon: 'check' },
  PARTIEL: { label: 'Partiel', cls: 'partiel' },
  PARTIELLEMENT_PAYEE: { label: 'Partiellement payée', cls: 'partiel' },
  IMPAYE: { label: 'Impayé', cls: 'impaye' },
  EMISE: { label: 'Émise', cls: 'impaye' },
  RETARD: { label: 'En retard', cls: 'retard', icon: 'warning' },
  BROUILLON: { label: 'Brouillon', cls: 'neutre' },
  ANNULEE: { label: 'Annulée', cls: 'annule' },
  ANNULE: { label: 'Annulé', cls: 'annule' },
  CONVERTIE: { label: 'Convertie', cls: 'neutre', icon: 'redo' },
  PROFORMA: { label: 'Proforma', cls: 'proforma' },
  AVOIR: { label: 'Avoir', cls: 'neutre' },
  EXPIREE: { label: 'Expirée', cls: 'annule' },
  CORBEILLE: { label: 'Corbeille', cls: 'annule' },
};

@Component({
  selector: 'bay-status-badge',
  template: `
    <span class="bay-badge" [ngClass]="'bay-badge-' + (def?.cls || 'neutre')">
      <span *ngIf="def?.icon" class="material-symbols-outlined" aria-hidden="true">{{ def.icon }}</span>{{ texte || def?.label || statut }}
    </span>
  `
})
export class StatusBadgeComponent {
  @Input() statut = '';
  /** Texte libre (ex. « Reste 20 000 ») : remplace le libellé du statut */
  @Input() texte = '';
  get def() { return STATUTS[this.statut]; }
}
